export default __webpack_public_path__ + "static/media/Aluminium Staircase.bf736b39.jpg";